// components/ArborDrawer/index.js
import { theme } from "@/theme/theme";
import Drawer from "@mui/material/Drawer";
import Divider from "@mui/material/Divider";
import { styled } from "@mui/material/styles";
import Image from "next/image";
import ArborLogoLight from "src/assets/arbor-logo-alt.png";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { ROUTES } from "@/constants/routes";
import Link from "next/link";
import useStore from "@/stores/store";
import { useRouter } from "next/router";
import CollapsibleSection from "./CollapsibleSection";
import BenchmarkSection from "./BenchmarkSection";
import IntegrationButton from "./IntegrationButton";
import ProfileSection from "./ProfileSection";

const drawerWidth = 256;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  marginBlockStart: 16,
  marginBlockEnd: 8,
  marginLeft: 16,
  ...theme.mixins.toolbar,
}));

const ArborDrawer = () => {
  const router = useRouter();
  const companyDrawerSettings = useStore(
    (state) =>
      state.companySettings?.find((setting) => setting.name === "DRAWER")?.value
  );

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          backgroundColor: theme.palette.primary.main,
        },
      }}
    >
      <DrawerHeader>
        <Link href={ROUTES.ROOT}>
          <Image
            src={ArborLogoLight}
            alt="arbor-logo-light"
            height={64}
            priority
          />
        </Link>
      </DrawerHeader>

      <Divider />
      <List>
        {companyDrawerSettings?.collect && (
          <CollapsibleSection 
            title="Collect"
            icon="SurveyIcon"
            items={companyDrawerSettings.collect}
            onClick={(setting) => router.push(`/${setting.type}`)}
          />
        )}
        
        {companyDrawerSettings?.analytics && (
          <CollapsibleSection 
            title="Analytics"
            icon="HubspotIcon"
            items={companyDrawerSettings.analytics}
            onClick={(setting) => {
              if (setting.type === "engagement") {
                router.push(
                  `${ROUTES.PORTFOLIO_ANALYTICS}/${setting.type}/${setting.instance_id}`
                );
              } else {
                router.push(`${ROUTES.ANALYTICS}/${setting.type}`);
              }
            }}
          />
        )}
        
        {companyDrawerSettings?.portfolio_analytics && (
          <CollapsibleSection 
            title="Portfolio Analytics"
            icon="HubspotIcon"
            items={companyDrawerSettings.portfolio_analytics}
            onClick={(setting) => 
              router.push(
                `${ROUTES.PORTFOLIO_ANALYTICS}/${setting.type}/${setting.instance_id}`
              )
            }
          />
        )}
        
        {companyDrawerSettings?.portfolio && (
          <CollapsibleSection 
            title="Portfolio"
            icon="HubspotIcon"
            items={companyDrawerSettings.portfolio}
            onClick={(setting) => 
              router.push(
                `${ROUTES.PORTFOLIO_ANALYTICS}/${setting.type}/${setting.instance_id}`
              )
            }
          />
        )}
        
        {companyDrawerSettings?.company && (
          <CollapsibleSection 
            title="Company"
            icon="HubspotIcon"
            items={companyDrawerSettings.company}
            onClick={(setting) => {
              if (setting.type === "engagement") {
                router.push(
                  `${ROUTES.PORTFOLIO_ANALYTICS}/${setting.type}/${setting.instance_id}`
                );
              } else if (setting.type === "collect/employee-overview") {
                router.push(`/${setting.type}`);
              } else {
                router.push(`${ROUTES.ANALYTICS}/${setting.type}`);
              }
            }}
          />
        )}
        
        {companyDrawerSettings?.benchmark && (
          <BenchmarkSection onNavigate={() => router.push(ROUTES.BENCHMAKRS)} />
        )}
      </List>
      
      <List
        sx={{
          flexGrow: 2,
          display: "flex",
          alignItems: "flex-end",
        }}
      >
        <ListItem sx={{ display: "block" }} disablePadding>
          {companyDrawerSettings?.integrations && (
            <IntegrationButton onNavigate={() => router.push(ROUTES.INTEGRATIONS)} />
          )}
          
          <ProfileSection />
        </ListItem>
      </List>
    </Drawer>
  );
};

export default ArborDrawer;






